(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('ContactService', [
        '$rootScope', 
        '$uibModal',
         ContactServiceFn]);
    
    function ContactServiceFn(
        $rootScope, 
        $uibModal) {

        var service = {
            showUserIsBeingModifiedPopUp: showUserIsBeingModifiedPopUp
        };

        return service;



        function showUserIsBeingModifiedPopUp(initialFirstName, initialLastName, newFirstName, newLastName) {
            // show modal
            return $uibModal.open({
                backdrop: false,
                keyboard: false,
                animation: true,
                templateUrl: '/app/agenda/templates/agenda-appointment-user-is-being-modified-popup.template.html',
                controller: 'AgendaAppointmentDetailUserIsBeingModifiedPopupController',
                controllerAs: 'vm',
                size: 'xs',
                resolve: {
                    firstName: function () {
                        return initialFirstName.trim();
                    },
                    lastName: function () {
                        return initialLastName.trim();
                    },
                    newFirstName: function () {
                        return newFirstName.trim();
                    },
                    newLastName: function () {
                        return newLastName.trim();
                    },
                },
            });
        }
    }
})();